const API_BASE_PATH = '/cloud-office/rest/uniAdapter';

export function getOauthRequestUrl(provider, adapterName) {
  const url = new URL(API_BASE_PATH + '/oauth/start.do', window.location.origin);
  url.search = new URLSearchParams({ provider, adapterName }).toString();
  return url.pathname + url.search;
}
